(() => {
  'use strict';

  const money = (cents) => {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  // ---------- DOM refs ----------
  const $ = s => document.querySelector(s);
  const drawer = $('#cartDrawer');
  const scrim = $('#cartScrim');
  const body = $('#cartBody');
  const empty = $('#cartEmpty');
  const foot = $('#cartFoot');
  const totalEl = $('#cartTotal');
  const cartBtn = document.querySelector('.cart-btn');
  const cartCount = document.querySelector('[data-cart-count]');
  const shipBar = $('#shipBar');
  const shipFill = $('#shipFill');
  const shipLabel = $('#shipLabel');
  const toast = $('#toast');
  const toastMsg = $('#toastMsg');

  const FREE_SHIP_CENTS = shipBar ? (parseInt(shipBar.dataset.threshold, 10) || 25) * 100 : 2500;

  let toastTimer;
  const showToast = (msg) => {
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-show'), 2200);
  };

  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // ---------- Shopify Ajax Cart ----------
  const fetchCart = () => fetch('/cart.js', {headers: {'Accept': 'application/json'}}).then(r => r.json());

  const addToCart = (id, quantity = 1, productTitle = 'Produkt') => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: id, quantity: quantity}]})
    }).then(r => r.json()).then(data => {
      if (data.status && data.status >= 400) {
        showToast(data.description || 'Fehler beim Hinzufügen');
      } else {
        showToast(productTitle + ' zum Korb hinzugefügt');
        refreshCart();
      }
      return data;
    });
  };

  const changeCartItem = (line, quantity) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({line: line, quantity: quantity})
    }).then(r => r.json()).then(() => refreshCart());
  };

  const clearCart = () => {
    return fetch('/cart/clear.js', {method: 'POST'}).then(() => {
      refreshCart();
      showToast('Warenkorb geleert');
    });
  };

  const refreshCart = () => {
    fetchCart().then(cart => {
      // count badge
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = cart.item_count ? '' : 'none';
      }

      // ship progress
      if (shipBar) {
        const pct = Math.min(100, (cart.items_subtotal_price / FREE_SHIP_CENTS) * 100);
        shipFill.style.width = pct + '%';
        const rest = FREE_SHIP_CENTS - cart.items_subtotal_price;
        if (rest <= 0) {
          shipBar.classList.add('is-full');
          shipLabel.innerHTML = '<b>Gratis-Versand</b> geschnappt! Zeit für die Kasse.';
        } else {
          shipBar.classList.remove('is-full');
          shipLabel.innerHTML = 'Nur noch <b>' + money(rest) + '</b> bis zum Gratis-Versand!';
        }
      }

      if (!body) return;

      if (cart.item_count === 0) {
        if (empty) empty.hidden = false;
        if (foot) foot.hidden = true;
        body.querySelectorAll('.cart-item').forEach(el => el.remove());
        return;
      }

      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;
      body.querySelectorAll('.cart-item').forEach(el => el.remove());

      cart.items.forEach((item, i) => {
        const row = document.createElement('div');
        row.className = 'cart-item';
        row.innerHTML =
          '<div class="swatch" style="background:var(--berry)">' +
            (item.image ? '<img src="' + item.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:12px;">' : item.product_title.charAt(0)) +
          '</div>' +
          '<div class="info">' +
            '<div class="name">' + item.product_title + '</div>' +
            '<div class="price">' + money(item.final_line_price) + '</div>' +
          '</div>' +
          '<div class="qty-ctrl">' +
            '<button data-dec="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Weniger">−</button>' +
            '<span class="q">' + item.quantity + '</span>' +
            '<button data-inc="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Mehr">+</button>' +
          '</div>' +
          '<button class="remove-btn" data-remove-line="' + (i + 1) + '" aria-label="Entfernen">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>' +
          '</button>';
        body.appendChild(row);
      });

      if (totalEl) totalEl.textContent = money(cart.items_subtotal_price);
    });
  };

  // ---------- Event delegation ----------
  document.addEventListener('click', (e) => {
    // add-to-cart via product-form
    const addForm = e.target.closest('form[action*="/cart/add"]');
    if (addForm && e.target.closest('button[type="submit"], .add-btn, .pdp-add, .gd-cta')) {
      e.preventDefault();
      const idInput = addForm.querySelector('input[name="id"], select[name="id"]');
      const qtyInput = addForm.querySelector('input[name="quantity"], input[id="QtyInput"]');
      const id = idInput ? idInput.value : null;
      const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      const productBtn = addForm.querySelector('[data-name]');
      const name = productBtn ? productBtn.dataset.name : 'Produkt';
      if (id) {
        addToCart(id, qty, name);
        // tap-squish animation
        const btn = addForm.querySelector('button, .add-btn');
        if (btn) {
          btn.classList.remove('tap-squish');
          void btn.offsetWidth;
          btn.classList.add('tap-squish');
        }
      }
      return;
    }

    // fav toggle
    const favBtn = e.target.closest('[data-fav]');
    if (favBtn) {
      e.preventDefault();
      favBtn.classList.toggle('is-fav');
      const isFav = favBtn.classList.contains('is-fav');
      const title = favBtn.closest('.product')?.querySelector('.p-title')?.textContent || 'Produkt';
      if (isFav) showToast(title + ' gemerkt');
      return;
    }

    // qty controls in drawer
    const inc = e.target.closest('[data-inc]');
    if (inc) { changeCartItem(parseInt(inc.dataset.inc, 10), parseInt(inc.dataset.qty, 10)); return; }
    const dec = e.target.closest('[data-dec]');
    if (dec) { changeCartItem(parseInt(dec.dataset.dec, 10), Math.max(0, parseInt(dec.dataset.qty, 10))); return; }
    const rm = e.target.closest('[data-remove-line]');
    if (rm) { changeCartItem(parseInt(rm.dataset.removeLine, 10), 0); showToast('Aus dem Korb entfernt'); return; }

    // open drawer via cart-btn (but let /cart page link work normally on cart page itself)
    if (e.target.closest('.cart-btn') && !window.location.pathname.includes('/cart')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('#cartClose') || e.target === scrim) { closeCart(); return; }
    if (e.target.closest('#cartClear')) { clearCart(); return; }

    // FAQ chips
    const chip = e.target.closest('.faq-cat');
    if (chip) {
      chip.parentElement.querySelectorAll('.faq-cat').forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      return;
    }

    // PDP variant chips (Klassik/XL/…)
    const varChip = e.target.closest('.var-chip');
    if (varChip) {
      e.preventDefault();
      const parent = varChip.parentElement;
      parent.querySelectorAll('.var-chip').forEach(c => c.classList.remove('is-active'));
      varChip.classList.add('is-active');
      // Sync hidden <select> if present
      const select = document.getElementById('ProductSelect');
      if (select && varChip.dataset.optionValue) {
        for (const opt of select.options) {
          if (opt.text.includes(varChip.dataset.optionValue)) {
            select.value = opt.value;
            break;
          }
        }
      }
      return;
    }

    // payment/shipping radio active state
    if (e.target.matches('.co-pay-opt input')) {
      const name = e.target.name;
      document.querySelectorAll('.co-pay-opt input[name="' + name + '"]').forEach(r => r.closest('.co-pay-opt').classList.toggle('is-sel', r.checked));
      return;
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('.co-pay-opt input')) {
      const name = e.target.name;
      document.querySelectorAll('.co-pay-opt input[name="' + name + '"]').forEach(r => r.closest('.co-pay-opt').classList.toggle('is-sel', r.checked));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
  });

  // Newsletter form: rely on Shopify's built-in customer form, add UX feedback
  document.addEventListener('submit', (e) => {
    if (e.target.classList.contains('nl-form')) {
      // Shopify submits the customer creation — our extra: toast (optimistic)
      const btn = e.target.querySelector('button');
      if (btn) {
        const orig = btn.textContent;
        btn.textContent = 'Drin ✓';
        setTimeout(() => { btn.textContent = orig; }, 2500);
      }
      showToast('Willkommen im Squish-Club — Check dein Postfach 🌸');
    }
  });

  // Initial cart state on page load
  refreshCart();
})();


/* ---------- Shop-Filter (client-side) ---------- */
(() => {
  const shopGrid = document.querySelector('.shop-grid');
  const shopSide = document.querySelector('.shop-side');
  if (!shopGrid || !shopSide) return;

  const catMap = {
    butter: ['butter'],
    mochi: ['mochi', 'dumpling'],
    kritter: ['kritter', 'capybara', 'axolotl', 'hippo'],
    mystery: ['mystery', 'blind', 'box']
  };
  const highlightMap = {
    neu: ['neu', 'new'],
    sale: 'onsale',
    viral: ['viral'],
    bestseller: ['bestseller']
  };

  function matches(card, filters) {
    const t = (card.dataset.type || '') + ' ' + (card.dataset.tags || '') + ' ' + (card.querySelector('.p-title')?.textContent || '').toLowerCase();
    const price = parseFloat(card.dataset.price || '0');
    // Category (OR)
    if (filters.cats.length && !filters.cats.some(c => (catMap[c] || [c]).some(k => t.includes(k)))) return false;
    // Price (single)
    if (filters.price === 'lo' && price >= 5) return false;
    if (filters.price === 'mid' && (price < 5 || price >= 8)) return false;
    if (filters.price === 'hi' && price < 8) return false;
    // Highlights (AND-lite: any match ok)
    if (filters.highlights.length) {
      const ok = filters.highlights.some(h => {
        if (highlightMap[h] === 'onsale') return card.dataset.onsale === '1';
        return (highlightMap[h] || [h]).some(k => t.includes(k));
      });
      if (!ok) return false;
    }
    return true;
  }

  function apply() {
    const filters = {
      cats: [...shopSide.querySelectorAll('input[type=checkbox]:checked')].filter(cb => Object.keys(catMap).includes(cb.value)).map(cb => cb.value),
      price: shopSide.querySelector('input[name=pr]:checked')?.value || 'all',
      highlights: [...shopSide.querySelectorAll('input[type=checkbox]:checked')].filter(cb => Object.keys(highlightMap).includes(cb.value)).map(cb => cb.value)
    };
    let visible = 0;
    shopGrid.querySelectorAll('.product').forEach(card => {
      const show = matches(card, filters);
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    const counter = document.querySelector('.shop-count b');
    if (counter) counter.textContent = visible;
  }

  shopSide.addEventListener('change', apply);
  window.shopFilterInit = true;
})();


/* ---------- PDP-Variantenauswahl: Bild + Preis + Add-to-Cart updaten ---------- */
(() => {
  const jsonEl = document.getElementById('ProductJSON');
  if (!jsonEl) return;
  let productData;
  try { productData = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  if (!productData || !productData.variants) return;

  const optionsContainers = document.querySelectorAll('.pdp-variants');
  const mainImg = document.getElementById('pdpMainImage');
  const priceEl = document.getElementById('pdpPrice');
  const priceOldEl = document.getElementById('pdpPriceOld');
  const addBtn = document.getElementById('pdpAddBtn');
  const addLabel = document.getElementById('pdpAddBtnLabel');
  const variantSelect = document.getElementById('ProductVariantSelect');
  if (!variantSelect) return;

  const money = cents => '€' + (cents / 100).toFixed(2).replace('.', ',');

  function currentOptions() {
    const opts = [];
    optionsContainers.forEach(container => {
      const active = container.querySelector('.var-chip.is-active');
      opts.push(active ? active.dataset.optionValue : null);
    });
    return opts;
  }

  function findVariant(selectedOpts) {
    return productData.variants.find(v => {
      return v.options.every((opt, i) => opt === selectedOpts[i]);
    });
  }

  function updatePDP(variant) {
    if (!variant) return;

    // Hidden Select / Input für Add-to-Cart-Form
    if (variantSelect.tagName === 'SELECT') {
      variantSelect.value = variant.id;
    } else {
      variantSelect.value = variant.id;
    }

    // Bild wechseln
    if (variant.featured_image && mainImg) {
      const url = variant.featured_image.src.replace(/(_|\.)(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.');
      // Shopify-Image-URLs: einfach ersetzen der Größe zu 800x
      let newSrc = variant.featured_image.src;
      // Ohne Modifikationen — Shopify liefert direkt die URL
      mainImg.src = newSrc;
      mainImg.alt = productData.title;
    }

    // Preis
    if (priceEl) priceEl.textContent = money(variant.price);
    if (priceOldEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceOldEl.textContent = money(variant.compare_at_price);
        priceOldEl.hidden = false;
      } else {
        priceOldEl.hidden = true;
      }
    }

    // Add-to-Cart Button
    if (addBtn && addLabel) {
      if (variant.available) {
        addBtn.disabled = false;
        addLabel.textContent = 'In den Korb — ' + money(variant.price);
      } else {
        addBtn.disabled = true;
        addLabel.textContent = 'Ausverkauft';
      }
    }
  }

  // Click-Handler für Variant-Chips
  document.querySelectorAll('.var-chip').forEach(chip => {
    chip.addEventListener('click', (e) => {
      e.preventDefault();
      const container = chip.closest('.pdp-variants');
      // Aktive Klasse in dieser Options-Gruppe wechseln
      container.querySelectorAll('.var-chip').forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');

      // Aktuelle Options-Kombination bilden und passende Variante finden
      const opts = currentOptions();
      const variant = findVariant(opts);
      updatePDP(variant);
    });
  });

  // Thumb-Klick: Hauptbild wechseln
  document.querySelectorAll('.pdp-thumbs .thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const url = thumb.dataset.imageUrl;
      if (url && mainImg) mainImg.src = url;
      document.querySelectorAll('.pdp-thumbs .thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  window.variantSwatchInit = true;
})();
